import { useSelector } from "react-redux";
import NotificationPreferencesButton from "./NotificationPreferencesButton";
import NotificationContantButton from "./NotificationContantButton";

export default function PushNotification() {
    const profile = useSelector(({ profile: { profiledata } }) => profiledata);

    return (
        <div className="account-preference col-md-6">
            <br />
            <h4 className="availability-head">Push Notification</h4>
            <div className="allow-notification">
                <h5>Allow notification</h5>
                <NotificationContantButton profile={profile} />
            </div>
            <>
                <h4 className="availability-head">Notify When</h4>
                <div className="new-task">
                    <NotificationPreferencesButton profile={profile} />
                </div>
            </>
        </div>
    )
}